module.exports = __webpack_public_path__ + "ad566a87.png";